export default {
  translate(value, language) {
    const formData = new FormData();
    formData.append('key', 'AIzaSyDn4WBvLcMsyUWDMWM71AUK3JHfTs8Vj3s');
    formData.append('q', value);
    formData.append('source', 'en');
    formData.append('format', 'text');
    formData.append('target', language);
    return fetch('https://translation.googleapis.com/language/translate/v2', {
      method: 'POST',
      body: formData,
    }).then((resp) => resp.json()).then((respJson) => respJson.data.translations[0].translatedText);
  },
};
